import { useEnvironment } from '@wix/yoshi-flow-editor';
import React from 'react';
import { FormNestedSlot } from '../../../../../types/formSelectedSlots';
import { SlotService } from '../../../../../utils/state/types';
import { TagName } from '../../../../../utils/tagName.const';
import Text, { TextType } from '../../../Text/Text';
import DateAndTime from '../../DateAndTime/DateAndTime';
import VideoConferenceBadge from '../../VideoConferenceBadge/VideoConferenceBadge';
import { SingleSlotDetailsDataHook } from './dataHooks';
import { MoreDetails } from './MoreDetails';
import PriceLine from './PriceLine/PriceLine';
import { SelectedAddons } from './SelectedAddons';
import { classes } from './SingleSlotDetails.st.css';

export type SingleSlotDetailsProps = {
  slotService: SlotService;
  slot: FormNestedSlot;
  totalNumberOfParticipants?: number;
  isSingleService: boolean;
  isCart: boolean | undefined;
};

const SingleSlotDetails: React.FC<SingleSlotDetailsProps> = ({
  slotService,
  slot,
  totalNumberOfParticipants,
  isSingleService,
  isCart,
}) => {
  const { isMobile } = useEnvironment();
  const { service, selectedPaymentOption } = slotService;
  const dynamicPriceTotalNumberOfParticipants =
    slotService.dynamicPriceInfo?.selectedVariants?.reduce(
      (acc, next) => (acc += next.numberOfParticipants || 0),
      0,
    );

  const renderMoreDetailsSection = () => {
    return !isMobile ? (
      <MoreDetails
        slotService={slotService}
        slot={slot}
        isSingleService={isSingleService}
      />
    ) : (
      <SelectedAddons slotService={slotService} />
    );
  };

  return (
    <div className={classes.root}>
      <Text
        type={TextType.Primary}
        data-hook={SingleSlotDetailsDataHook.SERVICE_NAME}
        tagName={TagName.Paragraph}
      >
        {service.name}
      </Text>
      <DateAndTime
        totalNumberOfSessions={service.totalNumberOfSessions}
        slot={slot}
        service={service}
      />
      <VideoConferenceBadge
        includesConferenceOption={service.includesConferenceOption}
      />
      {renderMoreDetailsSection()}
      {!isSingleService &&
        (slotService.dynamicPriceInfo?.selectedVariants?.length ? (
          slotService.dynamicPriceInfo.selectedVariants.map((variant) => (
            <PriceLine
              key={variant?.choices?.[0].optionId}
              dataHook={SingleSlotDetailsDataHook.PRICE_LINE}
              selectedPaymentOption={selectedPaymentOption}
              slotService={slotService}
              selectedVariant={variant}
              totalNumberOfParticipants={dynamicPriceTotalNumberOfParticipants}
              isCart={isCart}
            />
          ))
        ) : (
          <PriceLine
            dataHook={SingleSlotDetailsDataHook.PRICE_LINE}
            selectedPaymentOption={selectedPaymentOption}
            slotService={slotService}
            totalNumberOfParticipants={totalNumberOfParticipants}
            isCart={isCart}
          />
        ))}
    </div>
  );
};

export default SingleSlotDetails;
